import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';
import {EQueryAttachment} from '../../models/e-query-attachment';

@Component({
    selector: 'e-query-attachments',
    template: require('./e-query-attachments.component.html'),
    styles: [require('./e-query-attachments.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class EQueryAttachmentsComponent {

    @Input()
    public attachments: EQueryAttachment[];

    @Output()
    public downloadAttachmentClick = new EventEmitter<number>();

    @Output()
    public previewAttachmentClick = new EventEmitter<number>();
}